var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('estudio',{attrs:{"documentId":parseInt(_vm.documentId),"projectId":parseInt(_vm.projectId)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }